import React from 'react';
import { Circle, Image, Layer, Rect, Stage, Text } from 'react-konva';
import CardPreviewApp from "./Functionality/CardPreviewApp";
import CustomModal from "../../components/Modal/CustomModal";
import CustomDescriptionLabel from "../../components/CustomDescriptionLabel";
import {DownloadIconSvg} from '../../components/buttons/IconButtons';
import CustomCard from '../../components/CustomCard';
import ButtonIcon from '../../components/buttons/ButtonIcon';
const CardPreview = (props) => {
    const { open, onHide, downloadCard=true } = props;
    const {
        t,
        cardWidth,
        cardHeight,
        cardBackgroundColor,
        previewRaw,
        stageFront,
        stageBack,
        handleDownload
    } = CardPreviewApp(props);

    return (
        <CustomModal
            title={"preview"}
            show={open}
            size="lg"
            cancelButton={false}
            confirmButton={false}
            onHide={onHide}
            classNameBody="pt-2"
        >
            <div className={"row"}>
                <div className={"col-sm-12 col-md-6 col-xxl-6 col-lg-6  p-0 m-0"}>
                    <div className={"col-12 d-flex justify-content-center align-items-center"}>
                        <CustomDescriptionLabel trans={t('front_side')}/>
                        {downloadCard &&
                            <ButtonIcon
                                id='btn_ae_user_restriction'
                                Icon={DownloadIconSvg}
                                title={'download_front_side'}
                                className='btn-background-transparent ml-2 mb-2'
                                iconProps='btn-icon-svg-gray btn-icon-svg-12px'
                                onClick={()=>{
                                    handleDownload(stageFront);
                                }}
                            />
                        }
                    </div>
                    <div className={"col-12 d-flex justify-content-center align-items-center"}>
                        <CustomCard
                            classContent={'px-0 py-0'}
                        >
                        <Stage
                            ref={stageFront}
                            width={cardWidth}
                            height={cardHeight}
                            scaleX={0.85}
                            scaleY={0.85}
                        >
                            <Layer>
                                <Rect
                                    id='background'
                                    width={cardWidth}
                                    height={cardHeight}
                                    fill={cardBackgroundColor}
                                />
                                {previewRaw &&
                                    previewRaw[1].combinedObject.map((shape, index) => {
                                        if (shape.property === 'squares' || shape.property === 'lines') {
                                            return (
                                                <Rect
                                                    key={index}
                                                    x={shape.x}
                                                    y={shape.y}
                                                    rotation={shape.rotation}
                                                    width={shape.width}
                                                    height={shape.height}
                                                    cornerRadius={shape.cornerRadius}
                                                    stroke={shape.stroke}
                                                    strokeWidth={shape.strokeWidth}
                                                    id={shape.id}
                                                    fill={shape.fill}
                                                />
                                            );
                                        } else if (shape.property === 'ellipsis') {
                                            return (
                                                <Circle
                                                    key={index}
                                                    x={shape.x - 10}
                                                    y={shape.y - 5}
                                                    rotation={shape.rotation}
                                                    radius={shape.radius}
                                                    fill={shape.fill}
                                                    stroke={shape.stroke}
                                                    strokeWidth={shape.strokeWidth}
                                                    id={shape.id}
                                                />
                                            );
                                        } else if (shape.property === 'texts') {
                                            return (
                                                <Text
                                                    key={index}
                                                    x={shape.x - 10}
                                                    y={shape.y - 5}
                                                    text={shape.content}
                                                    fontSize={shape.fontSize}
                                                    fontFamily={shape.fontFamily}
                                                    fontStyle={shape.fontStyle}
                                                    textDecoration={shape.textDecoration}
                                                    fill={shape.fill}
                                                    align={shape.align}
                                                    width={shape.width}
                                                    height={shape.height}
                                                    wrap={true}
                                                    id={shape.id}
                                                />
                                            );
                                        } else if (shape.property === 'resources') {
                                            const imageObject = new window.Image();
                                            imageObject.src = shape.base64;
                                            return (
                                                <Image
                                                    key={index}
                                                    image={imageObject}
                                                    x={shape.x}
                                                    y={shape.y}
                                                    rotation={shape.rotation}
                                                    width={shape.width}
                                                    height={shape.height}
                                                    id={shape.id}
                                                />
                                            );
                                        }
                                        return null;
                                    })}
                            </Layer>
                        </Stage>
                        </CustomCard>
                    </div>
                </div>
                <div className={"col-sm-12 col-md-6 col-xxl-6 col-lg-6  p-0 m-0"}>
                    <div className={"col-12 d-flex justify-content-center align-items-center"}>
                        <CustomDescriptionLabel trans={t('back_side')}/>
                        {downloadCard &&
                            <ButtonIcon
                                id='btn_ae_user_restriction'
                                Icon={DownloadIconSvg}
                                title={'download_back_side'}
                                className='btn-background-transparent ml-2 mb-2'
                                iconProps='btn-icon-svg-gray btn-icon-svg-12px'
                                onClick={()=>{
                                    handleDownload(stageBack);
                                }}
                            />
                        }
                    </div>
                    <div className={"col-12 d-flex justify-content-center align-items-center"}>
                        <CustomCard
                            classContent={'px-0 py-0'}
                        >
                        <Stage
                            ref={stageBack}
                            width={cardWidth}
                            height={cardHeight}
                            scaleX={0.85}
                            scaleY={0.85}
                        >
                            <Layer>
                                <Rect
                                    id='background'
                                    width={cardWidth}
                                    height={cardHeight}
                                    fill={cardBackgroundColor}
                                />
                                {previewRaw &&
                                    previewRaw[2].combinedObject.map((shape, index) => {
                                        if (shape.property === 'squares' || shape.property === 'lines') {
                                            return (
                                                <Rect
                                                    key={index}
                                                    x={shape.x}
                                                    y={shape.y}
                                                    rotation={shape.rotation}
                                                    width={shape.width}
                                                    height={shape.height}
                                                    cornerRadius={shape.cornerRadius}
                                                    stroke={shape.stroke}
                                                    strokeWidth={shape.strokeWidth}
                                                    id={shape.id}
                                                    fill={shape.fill}
                                                />
                                            );
                                        } else if (shape.property === 'ellipsis') {
                                            return (
                                                <Circle
                                                    key={index}
                                                    x={shape.x - 10}
                                                    y={shape.y - 5}
                                                    rotation={shape.rotation}
                                                    radius={shape.radius}
                                                    fill={shape.fill}
                                                    stroke={shape.stroke}
                                                    strokeWidth={shape.strokeWidth}
                                                    id={shape.id}
                                                />
                                            );
                                        } else if (shape.property === 'texts') {
                                            return (
                                                <Text
                                                    key={index}
                                                    x={shape.x - 10}
                                                    y={shape.y - 5}
                                                    text={shape.content}
                                                    fontSize={shape.fontSize}
                                                    fontFamily={shape.fontFamily}
                                                    fontStyle={shape.fontStyle}
                                                    textDecoration={shape.textDecoration}
                                                    fill={shape.fill}
                                                    align={shape.align}
                                                    width={shape.width}
                                                    height={shape.height}
                                                    wrap={true}
                                                    id={shape.id}
                                                />
                                            );
                                        } else if (shape.property === 'resources') {
                                            const imageObject = new window.Image();
                                            imageObject.src = shape.base64;
                                            return (
                                                <Image
                                                    key={index}
                                                    image={imageObject}
                                                    x={shape.x}
                                                    y={shape.y}
                                                    rotation={shape.rotation}
                                                    width={shape.width}
                                                    height={shape.height}
                                                    id={shape.id}
                                                />
                                            );
                                        }
                                        return null;
                                    })}
                            </Layer>
                        </Stage>
                        </CustomCard>
                    </div>
                </div>
            </div>
        </CustomModal>
    );
};

export default CardPreview;
